<script setup lang="ts">
import type { AgentOnPage } from '@@/shared/agent/api-types';

withDefaults(
  defineProps<{
    agent: AgentOnPage
    variant?: 'lite' | 'full'
    titleTag?: 'h2' | 'h3'
  }>(),
  {
    variant: 'lite',
    titleTag: 'h2',
  },
);
</script>

<template>
  <IadWrapper
    :class="{ 'bg-neutral-80': variant === 'full' }"
    inner-classes="flex flex-col gap-l py-2xl px-m md:px-0"
    :padded="false"
  >
    <div>
      <IadTitle
        :text="$t(`agent.reviews.title`)"
        :tag="titleTag"
        :variant="variant === 'full' ? 'large' : 'medium'"
      />
      <IadReviewSummary
        v-if="agent.reviewsCount"
        class="pt-xs"
        :average-rating="agent.reviewsRatingAverage"
        :reviews-count="agent.reviewsCount"
      />
    </div>

    <div class="flex flex-wrap md:justify-center gap-m">
      <IadReview
        v-for="review of agent.reviews"
        :key="review.id"
        :review
        :variant
      />
    </div>

    <div class="flex justify-center">
      <IadBtn
        :href="agent.reviewsExternalUrl"
        target="_blank"
        variant="outlined"
        size="large"
        :text="$t(`agent.reviews.discover_cta`)"
      />
    </div>
    <div
      v-if="variant === 'full'"
      class="flex flex-col gap-l lg:flex-row items-center justify-center px-xl py-m mx-auto max-w-[830px] rounded-2xl"
      :class="{
        'bg-white': variant === 'full',
      }"
    >
      <img
        loading="lazy"
        class="flex-none w-24 h-auto"
        src="~/assets/images/immodvisor/warranty.png"
      >
      <div class="flex-1 text-center">
        <p
          class="text-sm pb-xs"
          v-text="$t(`agent.reviews.immodvisor.description`)"
        />
        <IadBtn
          href="https://www.immodvisor.com/nos-engagements"
          variant="link"
          target="_blank"
          :text="$t(`agent.reviews.immodvisor.cta`)"
        />
      </div>
    </div>
  </IadWrapper>
</template>
